import {
  CPTSlabForManualOption,
  CPTSlabManualDisplay,
} from "../../../../views/Orders/enums";

export const MANUAL_CPT_SLAB_OPTIONS = [
  {
    value: CPTSlabForManualOption.DIRECT_DELIVERY,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.DIRECT_DELIVERY],
    icon: "🏎️",
  },
  {
    value: CPTSlabForManualOption.AGGREGATED_DELIVERY,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.AGGREGATED_DELIVERY],
    icon: "🚚",
  },
  {
    value: CPTSlabForManualOption.SELF_PICKUP,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.SELF_PICKUP],
    icon: "🚶",
  },
];
